import React from 'react'
import PageTitle from '../hooks/PageTitle'
import PageHeader from '../layouts/PageHeader'

const Publication = () => {
  return (
    <>
        <PageTitle title="Publication"/>
        <PageHeader headerTitle="Publication"/>
    </>
  )
}

export default Publication